export { default } from "./KeyTermButton";
